import React, { useState, useEffect } from "react"
import { get } from "helpers/api_helper"
import { SUBSCRIPTION } from "helpers/url_helper"

const Subscription = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => { getSubscription(); }, [])

    const getSubscription = async () => {
        setLoading(true);
        const res = await get(SUBSCRIPTION);
        if (res.status === 200) setData(res?.response);
        setLoading(false);
    }

    const getDaysRemaining = () => {
        if (!data?.renewal_date) return null;
        const diff = new Date(data.renewal_date) - new Date();
        return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
    }

    const daysLeft = getDaysRemaining();
    const progressColor = daysLeft > 30 ? "#22c55e" : daysLeft > 7 ? "#f59e0b" : "#ef4444";

    const box = { background:"#f8fafc", borderRadius:"10px", padding:"20px", marginBottom:"20px", border:"1px solid #e2e8f0" };
    const lbl = { fontSize:"11px", fontWeight:"600", color:"#94a3b8", textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:"4px" };

    if (loading) return (
        <div style={{ textAlign:"center", padding:"40px" }}>
            <i className="fas fa-spinner fa-spin text-primary" style={{ fontSize:"24px" }}></i>
            <p style={{ marginTop:"10px", color:"#94a3b8", fontSize:"13px" }}>Loading subscription...</p>
        </div>
    );

    return (
        <div>
            {/* Plan badge */}
            <div style={{ background:"linear-gradient(135deg, #1e293b 0%, #334155 100%)", borderRadius:"12px", padding:"24px", marginBottom:"20px", color:"#fff", position:"relative", overflow:"hidden" }}>
                <div style={{ position:"absolute", top:"-20px", right:"-20px", width:"100px", height:"100px", borderRadius:"50%", background:"rgba(255,255,255,0.05)" }} />
                <div style={{ position:"absolute", bottom:"-30px", left:"30px", width:"160px", height:"160px", borderRadius:"50%", background:"rgba(255,255,255,0.03)" }} />
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                    <div>
                        <div style={{ fontSize:"11px", color:"#94a3b8", fontWeight:"600", textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:"8px" }}>
                            <i className="bx bx-crown" style={{ color:"#fbbf24", marginRight:"6px" }}></i> Current Plan
                        </div>
                        <div style={{ fontSize:"28px", fontWeight:"800", letterSpacing:"-0.5px" }}>{data?.package || "Standard"}</div>
                        <div style={{ marginTop:"6px", fontSize:"13px", color:"#94a3b8" }}>Dental Lab ERP System</div>
                    </div>
                    <div style={{ textAlign:"right" }}>
                        <div style={{ background:"#22c55e", color:"#fff", padding:"4px 12px", borderRadius:"20px", fontSize:"12px", fontWeight:"700", display:"inline-block" }}>
                            <i className="fas fa-circle" style={{ fontSize:"8px", marginRight:"5px" }}></i> Active
                        </div>
                    </div>
                </div>

                {daysLeft !== null && (
                    <div style={{ marginTop:"20px" }}>
                        <div style={{ display:"flex", justifyContent:"space-between", marginBottom:"6px" }}>
                            <span style={{ fontSize:"12px", color:"#94a3b8" }}>Subscription validity</span>
                            <span style={{ fontSize:"12px", fontWeight:"700", color: daysLeft > 30 ? "#86efac" : daysLeft > 7 ? "#fde68a" : "#fca5a5" }}>
                                {daysLeft} days left
                            </span>
                        </div>
                        <div style={{ height:"6px", background:"rgba(255,255,255,0.1)", borderRadius:"3px", overflow:"hidden" }}>
                            <div style={{ height:"100%", background: progressColor, borderRadius:"3px", width:`${Math.min(100, (daysLeft / 365) * 100)}%`, transition:"width 1s ease" }} />
                        </div>
                    </div>
                )}
            </div>

            {/* Dates */}
            <div style={box}>
                <div style={{ fontWeight:"700", fontSize:"13px", color:"#334155", marginBottom:"16px", display:"flex", alignItems:"center", gap:"8px" }}>
                    <i className="bx bx-calendar text-primary"></i> Subscription Dates
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:"16px" }}>
                    <div style={{ textAlign:"center", padding:"16px", background:"#f0fdf4", borderRadius:"8px", border:"1px solid #bbf7d0" }}>
                        <div style={lbl}>Activation Date</div>
                        <div style={{ fontWeight:"700", fontSize:"15px", color:"#16a34a" }}>{data?.subscription_date || "—"}</div>
                        <i className="bx bx-check-circle" style={{ color:"#22c55e", fontSize:"20px", marginTop:"6px", display:"block" }}></i>
                    </div>
                    <div style={{ textAlign:"center", padding:"16px", background:"#fffbeb", borderRadius:"8px", border:"1px solid #fde68a" }}>
                        <div style={lbl}>Renewal Reminder</div>
                        <div style={{ fontWeight:"700", fontSize:"15px", color:"#d97706" }}>{data?.reminder_date || "—"}</div>
                        <i className="bx bx-bell" style={{ color:"#f59e0b", fontSize:"20px", marginTop:"6px", display:"block" }}></i>
                    </div>
                    <div style={{ textAlign:"center", padding:"16px", background:"#fff1f2", borderRadius:"8px", border:"1px solid #fecdd3" }}>
                        <div style={lbl}>Expiry Date</div>
                        <div style={{ fontWeight:"700", fontSize:"15px", color:"#dc2626" }}>{data?.renewal_date || "—"}</div>
                        <i className="bx bx-x-circle" style={{ color:"#ef4444", fontSize:"20px", marginTop:"6px", display:"block" }}></i>
                    </div>
                </div>
            </div>

            <div style={{ background:"#eff6ff", borderRadius:"10px", padding:"16px", border:"1px solid #bfdbfe", display:"flex", alignItems:"center", gap:"12px" }}>
                <i className="bx bx-info-circle" style={{ color:"#2563eb", fontSize:"20px", flexShrink:0 }}></i>
                <div style={{ fontSize:"13px", color:"#1e40af" }}>
                    To upgrade your plan or extend your subscription, please contact <strong>support@catchysystem.com</strong> or call your account manager.
                </div>
            </div>
        </div>
    );
}

export default Subscription;
